import { VehicleSelectionOption } from "api/interfaces/garage-apis";
import { ISetVehicleFromGetPageDetails } from "../interfaces/garage.interface";

function setVehicleFromGetPageDetails(data: {
    vehicleSelectionOptions: VehicleSelectionOption[];
    nextVehicleSelectionOption: string;
    vehicleSelectionOptionType: string;
  }): ISetVehicleFromGetPageDetails {
  return {
    type: "SET_VEHICLE_FROM_GET_PAGE_DETAILS",
    data,
  };
}
export default setVehicleFromGetPageDetails;
